//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../no/SelectTaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.RefitControlBuilder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"ConstraintUMax",0,"GeometricUtilities.Continuity",0],[1,"ConstraintUMin",0,"GeometricUtilities.Continuity",0],[1,"ConstraintVMax",0,"GeometricUtilities.Continuity",0],[1,"ConstraintVMin",0,"GeometricUtilities.Continuity",0],[1,"Face",0,"SelectTaggedObject",0],[0,"FitDirection",1,"Direction",0],[0,"HasFitDirection",1,0],[0,"IsCreateCopy",1,0],[0,"MaxCheckingDist",1,0],[0,"ModificationPercent",1,0],[1,"RefitControl",0,"GeometricUtilities.RefitControlBuilder",0],[0,"SmoothFactor",1,0],[1,"Targets",0,"SelectTaggedObjectList",0],[0,"Type",1,0],[0,"UseConstraintsAll",1,0]],[],[]];
SPLM.Features.RefitFaceBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.RefitFaceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.RefitFaceBuilder.Types = Object.freeze({
    "Refit" : "Refit", "FitToTarget" : "FitToTarget"});

export default SPLM;